let httpUrl = {}
// let proUrl = 'https://web.api.rongchuangmianyang.com'; // 线上 绵阳
let devUrl = 'http://my.webapi.weitianshi.com.cn'; // 测试 绵阳
let proUrl = 'https://wts.weitianshi.cn' // 线上 微天使
// let devUrl = 'http://my.webapi.weitianshi.com.cn' // 测试 微天使https://pc.dev.weitianshi.cn
// let devUrl = 'https://pc.dev.weitianshi.cn' // 测试 微天使https://pc.dev.weitianshi.cn

httpUrl.devUrl = proUrl
httpUrl.proUrl = proUrl

// httpUrl.wxUrl = 'https://wx.rongchuangmiangyang.com' // url.js 文件中，使用微信二维码地方使用  绵阳
// httpUrl.wxUrl = 'http://my.wtscn.weitianshi.com.cn' // url.js 文件中，使用微信二维码地方使用  绵阳
httpUrl.wxUrl = 'https://wx.weitianshi.cn/api/wx/getProjectQr' // url.js 文件中，使用微信二维码地方使用 微天使

httpUrl.systemName = '微天使' // 创投服务生态链接者
httpUrl.systemDesc = '创投服务生态链接者'
// httpUrl.systemName = '融创绵阳'
// httpUrl.systemDesc = '创新创业综合服务平台'

// httpUrl.domainName = 'https://web.rongchuangmianyang.com' // 访问的域名地址 绵阳线上
// httpUrl.domainName = 'http://my.wtscn.weitianshi.com.cn' // 访问的域名地址 绵阳测试 http://127.0.0.1:8080
// httpUrl.domainName = 'http://127.0.0.1:8080' // 访问的域名地址 本地 如果是localhost 可改成这个
// httpUrl.domainName = 'http://my.wtscn.weitianshi.com.cn' // 访问的域名地址  http://my.webapi.weitianshi.com.cn对应的访问地址
httpUrl.domainName = 'https://www.weitianshi.cn' // 访问的域名地址  微天使线上

httpUrl.wxLogin_appid = 'wx9de571b0aa850c03' // 微天使线上 微信登录方式所用参数
// httpUrl.wxLogin_appid = 'wx27e11beb582b743c'// 融创绵阳线上 微信登录方式所用参数

httpUrl.dasai_test_url = 'http://dasai.weitianshi.cn'; // 大赛系统的测试服  http://my.dasai.weitianshi.com.cn  http://dasai.weitianshi.cn
httpUrl.zst_test_url = 'http://sp.weitianshi.cn'; // 招商通系统的测试服  http://my.sp.weitianshi.com.cn  http://sp.weitianshi.cn
export default httpUrl



// WEBPACK FOOTER //
// ./src/api/config.js